import React, { useState, useEffect, useRef } from 'react';
import { Menu, MenuItem, FormControl, IconButton, TextField } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import { getDateOperators } from '../../list.functions';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs'
import DateBetweenFilterElement from './DateBetweenFilterElement';
import DateAfterBeforeFilterElement from './DateAfterBeforeFilterElement';
import JSONPretty from 'react-json-pretty';
import { getFullscreenPortalContainer } from 'src/mtska-frontend-app-component/utils/fullscreenPortalContainer';

const DateFilter = ({ item, applyValue, showOperatorChange = false, label }) => {
    const prevOperator = useRef('between')
    const [operator, setOperator] = useState(item?.operator || prevOperator.current);
    const [value, setValue] = useState();
    const [focused, setFocused] = useState(false);
    const { t } = useTranslation();
    const operatorList = getDateOperators(t)
    const isValueInputDisabled = operator === 'isEmpty' || operator === 'isNotEmpty';
    const shouldShrinkLabel = focused || !!value || isValueInputDisabled;

    const handleValueChange = (value) => {
        setValue(value);
        applyValue({ ...item, operator: operator, value: value })
    };

    const handleOperatorChange = (operator) => {
        setOperator(operator);
        handleClose();
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        if (!operator || operator == prevOperator.current) return;

        prevOperator.current = operator;

        if (operator === 'isEmpty' || operator === 'isNotEmpty') {
            setValue('');
            handleValueChange(' ');
        } else if (['after', 'before'].includes(operator) && value?.from) {
            handleValueChange(value?.from);
        } else if (['after', 'before'].includes(operator) && typeof value === 'string') {
            handleValueChange(value);
        } else if (operator == 'between' && typeof value === 'string') {
            handleValueChange({ from: value, to: dayjs().format('YYYY-MM-DD') });
        } else if (operator == 'between' && typeof value === 'object') {
            handleValueChange(value);
        }
    }, [operator]);

    useEffect(() => {
        if (!item) return;
        setValue(item?.value || '');
    }, [item]);

    return (
        <FormControl variant="standard" size="small" className='mtska-list-filter-wrapper'>
            {
                ['between'].includes(operator) && <DateBetweenFilterElement operator={operator} value={value} label={label} handleValueChange={handleValueChange} setFocused={setFocused} />
            }
            {
                ['after', 'before'].includes(operator) && <DateAfterBeforeFilterElement operator={operator} value={value} label={label} handleValueChange={handleValueChange} setFocused={setFocused} />
            }
            {
                isValueInputDisabled && (
                    <TextField
                        variant="standard"
                        size="small"
                        className="mtska-list-filter-value"
                        value=""
                        disabled
                        label={label ? t(label) : t(operator)}
                        InputLabelProps={{ shrink: shouldShrinkLabel }}
                    />
                )
            }

            {showOperatorChange &&
                <IconButton
                    size="small"
                    onClick={handleOpen}
                >
                    <FilterListIcon fontSize="small" />
                </IconButton>
            }

            {showOperatorChange &&
                <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    container={getFullscreenPortalContainer}
                >
                    {operatorList.map((operator) => (
                        <MenuItem
                            key={operator.value}
                            value={operator.value}
                            onClick={() => handleOperatorChange(operator.value)}
                        >
                            {operator.label}
                        </MenuItem>
                    ))}
                </Menu>
            }
        </FormControl>
    );
};

export default DateFilter;
